export default __webpack_public_path__ + "static/media/D_Dado.b22fede1.mp3";